import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const CustomRadioButton = ({ id, name, checked, label, value, onChange }) => {
  return (
    <label
      htmlFor={id}
      className="inline-flex items-center cursor-pointer text-[.9rem] text-nowrap text-text-primary"
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="hidden"
        value={value}
      />
      <div
        className={`min-w-7 flex font-bold text-sm justify-center h-7 items-center border border-edge-strong mr-2 rounded-full transition-all duration-200 ${
          checked
            ? "bg-gradient-to-br from-emerald-400 to-emerald-600 text-white shadow-lg shadow-emerald-500/25"
            : "bg-input-bg"
        }`}
      >
        {checked && (
          <FontAwesomeIcon icon={faCheck} className="w-3 h-3 text-white" />
        )}
      </div>
      {label}
    </label>
  );
};

export default CustomRadioButton;
